/*
  LA affiliate tıklama sayacı (10 Eki 2026, Outlinks uygulamasının yerine).
  Affiliate "Buy Now" bağlantıları (data-la-aff="<ürün handle>", data-la-aff-konum="ana|bar")
  tıklanınca bulut/dis-link Worker'ına sendBeacon ile tek satır gider. Çerez yok,
  bağlantının kendisine dokunulmaz (sayaç düşse bile ziyaretçi partner sitesine gider).
  Önizleme teması / tema editörü / ?la_test=1 tıklamaları "test" işaretlenir, panelde sayılmaz.
  Panel: https://la-dis-link.bdias-llc.workers.dev/panel?anahtar=...
*/
(function () {
  if (window.__laAff) return;
  window.__laAff = true;
  var ADRES = 'https://la-dis-link.bdias-llc.workers.dev/c';
  var son = {};

  function testMi() {
    var s = window.Shopify || {};
    return /[?&]la_test=1/.test(location.search) || !!s.designMode || !!(s.theme && s.theme.role && s.theme.role !== 'main');
  }

  function gonder(a) {
    var urun = a.getAttribute('data-la-aff');
    if (!urun) return;
    var simdi = Date.now();
    if (son[urun] && simdi - son[urun] < 1500) return; // çift tık
    son[urun] = simdi;
    var govde = JSON.stringify({ u: urun, k: a.getAttribute('data-la-aff-konum') || 'diger', t: testMi() ? 1 : 0 });
    try { if (navigator.sendBeacon && navigator.sendBeacon(ADRES, govde)) return; } catch (e) {}
    try { fetch(ADRES, { method: 'POST', body: govde, keepalive: true, mode: 'no-cors' }); } catch (e) {}
  }

  function dinle(e) {
    if (e.type === 'auxclick' && e.button !== 1) return; // yalnız orta tık (yeni sekme)
    var a = e.target && e.target.closest && e.target.closest('a[data-la-aff]');
    if (a) gonder(a);
  }
  document.addEventListener('click', dinle, true);
  document.addEventListener('auxclick', dinle, true);
})();
